import React, { useEffect, useState } from 'react'
import { Linking, View } from 'react-native'
import ReactGA from 'react-ga'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigation } from '@react-navigation/native'

import AuthContainer from '../../navigation/layouts/Auth/AuthContainer'
import LoginForm from './LoginForm'
import Loading from '../../components/LoadIndicator'
import DemoError from '../../components/DemoError'

import loginActions from '../../redux/login/loginActions'
import { loginSelector } from '../../redux/login/loginSelector'
import { NeedHelpModal } from '../../components'
import { getEquipmentTypes, getTimeZone, getAvatar, getHotOffers, getOffers } from '../../redux/initReducer/initActions'
import { useChat } from '../../tools/general'
import { useDemo } from '../../hooks/useDemo'
import notificationActions from '../../redux/notifications/notificationActions'

ReactGA.pageview('/login')

function Login () {
  const { loading, error } = useSelector(loginSelector)
  const dispatch = useDispatch()
  const navigation = useNavigation()
  const [openModal, setOpenModal] = useState(false)
  const initChat = useChat()

  const onLogin = payload => {
    const initRequests = (email) => {
      initChat(email)
      dispatch(getEquipmentTypes())
      dispatch(getTimeZone())
      dispatch(getAvatar())
      dispatch(getHotOffers())
      dispatch(getOffers())
    }

    dispatch(loginActions.login(payload, initRequests))
  }

  const { isDemo, demoLoading, demoError, userAdded } = useDemo(onLogin)
  useEffect(() => {
    if (!userAdded && error) {
      dispatch(notificationActions.SendToast({ message: error, type: 'error' }))
    }
  }, [error, dispatch, userAdded])

  const onResetPassword = () => navigation.navigate('forgot-password')

  const handleOpenModal = () => setOpenModal(!openModal)

  const handleSignUp = () => Linking.openURL('https://share.hsforms.com/1uWn17TCaRwuD9u4r9gen3w4q78p')
  const goToDemo = () => Linking.openURL('https://capacity-demo.edgelogistics.com')

  if (isDemo && demoLoading && !demoError) {
    return (
      <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
        <Loading />
      </View>
    )
  }

  if (demoError) {
    return <DemoError />
  }

  return (
    <>
      <AuthContainer>
        <LoginForm
          loading={loading}
          onLogin={onLogin}
          onResetPassword={onResetPassword}
          onSignUp={handleSignUp}
          onOpenHelpModal={handleOpenModal}
          onDemoRedirection={goToDemo}
        />
      </AuthContainer>
      <NeedHelpModal
        open={openModal}
        onClose={handleOpenModal}
      />
    </>
  )
}

export default Login
